module.exports = __webpack_public_path__ + "6515c6de964e438544553201bf3a60cc.pdf";